import type { z } from 'zod'

import type { AnyValue, ZodInfer } from './utility-types.ts'

export const satisfiesSchema = <Schema extends z.ZodType>(
  schema: Schema,
  input: AnyValue
): input is ZodInfer<Schema> => schema.safeParse(input).success
